export interface Category {
  name: string;
  icon: string;
  url: string;
  desc: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    icon: "ri-footprint-line",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    desc: "Scarpe originali e replica di alta qualità dai migliori venditori",
  },
  {
    name: "Hoodies/Sweaters",
    icon: "ri-t-shirt-line",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    desc: "Felpe, hoodie e maglioni delle migliori marche streetwear",
  },
  {
    name: "T-Shirts",
    icon: "ri-shirt-line",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    desc: "T-shirt di design, basic ed edizioni limitate per ogni stile",
  },
  {
    name: "Jackets",
    icon: "ri-user-line",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    desc: "Giacche, bomber e giubbotti per tutte le stagioni",
  },
  {
    name: "Pants/Shorts",
    icon: "ri-scissors-line",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    desc: "Pantaloni, jeans, shorts e cargo dei brand più ricercati",
  },
  {
    name: "Headwear",
    icon: "ri-user-star-line",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    desc: "Cappelli, berretti e accessori per la testa di tendenza",
  },
  {
    name: "Sets",
    icon: "ri-layout-grid-line",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    desc: "Set coordinati e outfit completi pronti da indossare",
  },
  {
    name: "Underwear/Underpants",
    icon: "ri-heart-line",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    desc: "Intimo, boxer e biancheria di qualità superiore",
  },
  {
    name: "Jersey",
    icon: "ri-trophy-line",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    desc: "Maglie da calcio, basket e sportive autentiche e replica",
  },
  {
    name: "Accessories",
    icon: "ri-star-line",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    desc: "Occhiali, portafogli, gioielli e accessori moda imperdibili",
  },
  {
    name: "Bags",
    icon: "ri-shopping-bag-line",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    desc: "Borse, zaini e borselli dei migliori marchi internazionali",
  },
  {
    name: "Belts",
    icon: "ri-link",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    desc: "Cinture eleganti e casual in pelle e materiali premium",
  },
  {
    name: "Perfumes",
    icon: "ri-drop-line",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    desc: "Profumi e fragranze originali a prezzi competitivi",
  },
  {
    name: "Other Stuff",
    icon: "ri-more-line",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    desc: "Scopri altri prodotti unici e articoli speciali",
  },
];